import React from 'react';
import styled from 'styled-components';

import type Tearsheet from 'stores/Tearsheet';

import RemoveTearsheetButton from './RemoveTearsheetButton';
import ViewTearsheetButton from './ViewTearsheetButton';

const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 9px 16px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 7px;
`;

const MainLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

const DateLabel = styled.div`
  font-size: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  color: #666;
`;

export interface TearsheetSummaryRowProps {
  tearsheet: Tearsheet;
}

function TearsheetSummaryRow({ tearsheet }: TearsheetSummaryRowProps) {
  return (
    <Container>
      <MainLabel>{tearsheet.data.name}</MainLabel>

      <ButtonsContainer>
        <DateLabel>{tearsheet.formattedDateModified}</DateLabel>
        <ViewTearsheetButton tearsheet={tearsheet} />
        <RemoveTearsheetButton tearsheet={tearsheet} />
      </ButtonsContainer>
    </Container>
  );
}

export default TearsheetSummaryRow;
